import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

const UpdateOrderModal = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <InfoIcon color="primary" />
          <Typography variant="h6">Update Order</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mt: 1 }}>
          Do you want to update the payment along with the order?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={() => onConfirm(false)} color="secondary" size="large">
          Do Not Update Payment
        </Button>
        <Button onClick={() => onConfirm(true)} color="primary" variant="contained" size="large">
          Update Payment
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateOrderModal;
